import styles from "../../../LoanRequestPage.module.scss";
import { OrderType } from "../../../../../../model/orders/orders";
// import { handleCopy } from "../../../../../../utils";
import { CreditEngineScore } from "../../../../../../model/customer/customer";
import { CreditInfo } from "../../../../../../model/credit-info/credit-info";

type Props = {
	orderDetails: CreditInfo | undefined;
	// creditEngineScore?: CreditEngineScore;
};

const FinancialInformationTab = ({ orderDetails }: Props) => {
	function getCreditEngineClassName(creditEngineScore: CreditEngineScore | undefined) {
		let creditEngineClassName;

		switch (creditEngineScore?.category) {
			case "No Credit History":
				creditEngineClassName = styles.noCredit;
				break;
			case "No Income Details":
				creditEngineClassName = styles.noIncome;
				break;
			case "Closed with Performing Loans":
				creditEngineClassName = styles.closedWithPerformingLoans;
				break;
			case "No Disbursed Date Reported":
				creditEngineClassName = styles.noDisbursedDate;
				break;
			case "Very High Risk":
				creditEngineClassName = styles.veryHighRisk;
				break;
			case "High Risk":
				creditEngineClassName = styles.highRisk;
				break;
			case "Moderate Risk":
				creditEngineClassName = styles.moderateRisk;
				break;
			case "Low Risk":
				creditEngineClassName = styles.lowRisk;
				break;
			default:
				break;
		}

		return creditEngineClassName;
	}

	const { financialInformation } = orderDetails || {  };

	return (
		<section className={styles.detailsTabWrapper}>
			<div className={styles.detailsContent}>
				{/* <div className={styles.item}>
					<div className={styles.label}>BVN Status</div>
					<div className={styles.value}><div className={styles.success}>Successfully Verified</div></div>
				</div> */}
				<div className={styles.item}>
					<div className={styles.label}>Meter Number</div>
					<div className={styles.value}>{financialInformation?.meterNumber}</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Name on Meter</div>
					<div className={styles.value}>{financialInformation?.nameOnMeter}</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Address on Meter</div>
					<div className={styles.value}>{financialInformation?.addressOnMeter}</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Total Amount paid</div>
					<div className={styles.value}>{financialInformation?.totalAmountPaid}</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Time Range</div>
					<div className={styles.value}>{financialInformation?.timeRange}</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Credit Score Value</div>
					<div className={styles.value}>{financialInformation?.creditScoreValue}</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Credit Score Status</div>
					<div className={styles.value}>{financialInformation?.creditStatus}</div>
				</div>
				
				
				
				{/* <div className={styles.item}>
					<div className={styles.label}>Income API</div>
					<div className={styles.value}><div className={styles.success}>Successful</div></div>
				</div> */}
				{/* <div className={styles.item}>
					<div className={styles.label}>Mono Customer ID</div>
					<div className={styles.value}>
						<div className={styles.copy} onClick={() => handleCopy("56583493")}>
							56583493 <CopyIcon />
						</div>
					</div>
				</div> */}
			</div>
		</section>
	);
};

export default FinancialInformationTab;

